import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { Context } from '../../context/Contex';
import polygonsService from '../../services/polygonsService'
import BuggetsPage from '../../pages/PolygonsPage/BuggetsPage/BuggetsPage'

const BudgetsContainer = () => {
  const history = useHistory()
  const [budgets, setBudgets] = useState()
  const [loading, setLoading] = useState(false)
  const dataBudgets = []
  const { unidad, permisos } = useContext(Context);

  /*= =======================================================================
  Get Presupuestos
======================================================================== */

  const getBudgets = () => {
    setLoading(true)
    polygonsService.getBudgets(unidad)
      .then((response) => {
        setLoading(false)
        setBudgets(response.data.data)
      })
      .catch((error) => {
        history.push('/home');
        console.log(error);
      });
  }

  useEffect(() => {
    getBudgets()
  }, [])

  const handleUpdate = params => {
    polygonsService.putBudget(params)
      .then(() => {
        getBudgets()
      })
      .catch((error) => {
        setLoading(false)
        history.push('/home');
        console.log(error);
      });
  }


  if (budgets) {
    try {
      budgets.forEach((value) => {
        dataBudgets.push({
          id: value.ID,
          nombre: value.NOMBRE,
          presupuesto: value.PRESUPUESTO,
        });
      });
    } catch (err) {
      console.log(err)
    }
  }

  const columns = [
    { title: 'Id', field: 'id', hidden: true },
    { title: 'Nombre', field: 'nombre' },
    { title: 'presupuesto', field: 'presupuesto' },
  ];

  return (
    <BuggetsPage
      budgets={dataBudgets}
      permisos={permisos}
      columns={columns}
      loading={loading}
      onUpdate={handleUpdate}
    />
  );

}

export default BudgetsContainer
